import HomeIntro from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/homeIntro';
import React, { useEffect, useState } from 'react';
import disableElementService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/disableElementService';
import { apiFetchData, apiFetchDataWithoutLangISO } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/apiService';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
import AxiosError from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/axiosError';
import pageConfig from '@PROJECT_ROOT/responsiveFrontendPagesConfiguration.json';
import Loader from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/loader';
import VacationSuggestions from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/vacationSuggestions';
import SpecialOffer from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/specialOffer';
import TopDestinations from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/topDestinations';
import NewsletterForm from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/newsletterForm';
import Loyality from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/loyality';
import AboutUsShort from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/aboutUsShort';
import SearchForm from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/searchForm';
import UniqueValueProposition from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/uniqueValueProposition';
import AttractiveOfferBanners from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/AttractiveOfferBanners';
import InternalLinks from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/internalLinks';
import IterableTrackingService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/iterableTrackingService';
import injectService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/injectService';
// Između ostaloga pod komentarom zbog ovoga bug-a #57702
// import LocalStoreSearchParameters from '@PROJECT_ROOT/assets/responsive-frontend/js/services/LocalStoreSearchParameters';
import {
    hasGivenMarketingConsent,
    HOME_PAGE_VIEW_LAST_MINUTE_ITEM,
    HOMEPAGE_LAST_MINUTE_ITEM,
    HOMEPAGE_LAST_MINUTE_ITEM_SEE_ALL,
    SEARCH_EVENT,
} from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';
import LoginForMoreBenefits from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/LoginForMoreBenefits';
import FeaturedAccommodation from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/featuredAccommodation';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import { runDeferredInBrowser } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/utils';
import { useCurrentUser } from '@PROJECT_ROOT/assets/responsive-frontend/js/contexts/PageContext';

// ResponseListener (PHP) zamjenjuje ovo sa SSR HTML-om iz featuredAccommodationRoute.js.
const FEATURED_ACCOMMODATION_HTML_FRAGMENT_PLACEHOLDER = 'FEATURED_ACCOMMODATION_HTML_FRAGMENT_PLACEHOLDER';

export default function HomeContent({
    publicResourcesSSR,
    temporaryPublicResourcesSSR,
    ssrSearchForm,
    temporarySearchFormDataSSR,
    ssrParameters,
    temporaryParametersDataSSR,
    lastMinuteOffersDataSSR,
}) {
    const parameters = temporaryParametersDataSSR ?? ssrParameters ?? null;
    const user = useCurrentUser(parameters?.userJWT);
    const [publicResources, setPublicResources] = useState(temporaryPublicResourcesSSR ?? publicResourcesSSR ?? null);
    const [lastMinuteOffersData, setLastMinuteOffersData] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [initialUserWishlist, setInitialUserWishlist] = useState(null);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [isLoadingOffers, setIsLoadingOffers] = useState(true);
    const [offersError, setOffersError] = useState(false);
    const showFeaturedAccommodation = !isLoadingOffers && !offersError && lastMinuteOffersData?.offers;
    const [, setSelectedFilters] = useState({
        location_id: '',
        from: '',
        to: '',
        p_dist: 0,
        persons_adult: 0,
        persons_0_3: 0,
        persons_4_11: 0,
        persons_12_17: 0,
        pet: 0,
        i_d: 0,
        f_length: 0,
    });

    useEffect(() => {
        if (!publicResources) {
            setIsLoading(true);
            Promise.all([
                apiFetchData(pageConfig.homePage.initialPathExtension),
                user?.id && !IS_FRAME_SERVICE && apiFetchDataWithoutLangISO(pageConfig.homePage.userWishlistPath),
            ])
                .then(([res1, res2]) => {
                    setPublicResources(res1.data);
                    injectService.injectStructuredData(
                        res1.data?.homePageStructuredData,
                        pageConfig.homePage.pageStructuredDataID,
                    );
                    setInitialUserWishlist(res2?.data);
                })
                .catch((err) => {
                    setErrorMsg(err);
                    reportError(err);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        } else if (!isLoading && !initialUserWishlist && !IS_FRAME_SERVICE) {
            if (user?.id) {
                apiFetchDataWithoutLangISO(pageConfig.homePage.userWishlistPath)
                    .then((res) => {
                        setInitialUserWishlist(res.data);
                    })
                    .catch((err) => {
                        reportError(err);
                    });
            } else {
                setInitialUserWishlist([]);
            }
        }
        disableElementService.removeServerSideRenderClass();
        window.isReactLoaded = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // DESC: Naknadno učitavanje kontenta za LM sekciju.
    useEffect(() => {
        if (lastMinuteOffersDataSSR?.offers) {
            // Podaci su već dohvaćeni na serveru, ne zovemo ponovno apiFetchData.
            setLastMinuteOffersData(lastMinuteOffersDataSSR);
            setIsLoadingOffers(false);
            return undefined;
        }
        const loadLastMinuteOffers = () => {
            apiFetchData(pageConfig.homePage.lastMinuteOffersPath)
                .then((res) => {
                    if (res.status === 200 && res.data?.offers) {
                        setLastMinuteOffersData(res.data);
                    } else {
                        setOffersError(true);
                        reportError(res);
                    }
                })
                .catch((err) => {
                    setOffersError(true);
                    reportError(err);
                })
                .finally(() => setIsLoadingOffers(false));
        };
        const cancelDeferredLoad = runDeferredInBrowser(loadLastMinuteOffers);

        return () => { cancelDeferredLoad?.(); };
    // lastMinuteOffersDataSSR se postavlja jednom u hydrateRoot-u i više se ne mijenja.
    }, [lastMinuteOffersDataSSR]);

    const serializeStateToQueryString = (filters) => {
        const integerKeys = ['persons_0_3', 'persons_adult', 'persons_12_17', 'persons_4_11'];
        const queryString = Object.keys(filters)
            .filter((key) => {
                const value = filters[key];
                return value !== false && value !== null && value !== undefined && value !== '' && value !== 0;
            })
            .map((key) => {
                let value = filters[key];
                if (integerKeys.includes(key)) {
                    value = parseInt(value, 10);
                }
                if (Array.isArray(value) || typeof value === 'object') {
                    value = JSON.stringify(value);
                }
                return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            })
            .join('&');
        return queryString;
    };

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
        return match ? decodeURIComponent(match[1]) : null;
    };

    const updateSelectedFilters = (updatedFilters, redirect) => {
        setSelectedFilters((prevState) => {
            const newSelectedFilters = {
                ...prevState,
                ...updatedFilters,
            };

            (async () => {
                const brevoEmail = getCookie('brevo_email');
                const iterableData = {
                    ...(newSelectedFilters.from && { checkInDate: newSelectedFilters.from }),
                    ...(newSelectedFilters.to && { checkOutDate: newSelectedFilters.to }),
                    ...(newSelectedFilters.selectedLocation && {
                        destination: newSelectedFilters.selectedLocation
                            .split(',')
                            .map((loc) => loc.trim()),
                    }),
                    ...(newSelectedFilters.location_id && { locationId: newSelectedFilters.location_id }),
                    ...((newSelectedFilters.persons_adult
                        || newSelectedFilters.persons_0_3
                        || newSelectedFilters.persons_4_11
                        || newSelectedFilters.persons_12_17) && {
                        persons:
                            (parseInt(newSelectedFilters.persons_adult, 10) || 0)
                            + (parseInt(newSelectedFilters.persons_0_3, 10) || 0)
                            + (parseInt(newSelectedFilters.persons_4_11, 10) || 0)
                            + (parseInt(newSelectedFilters.persons_12_17, 10) || 0),
                    }),
                    ...(brevoEmail && { brevo_email: brevoEmail }),
                };
                if (redirect) {
                    if (user?.id && hasGivenMarketingConsent()) {
                        IterableTrackingService.postData(SEARCH_EVENT, iterableData);
                    }
                    const encryptedParams = serializeStateToQueryString(newSelectedFilters);
                    disableElementService.addDisabledClassOnBody('disableCurrentElementContent--transparent');
                    try {
                        const res = await apiFetchData('quick-search-action-url/', `?${encryptedParams}`);
                        if (res.status === 200) {
                            let redirectURL = res.data.url;
                            if (res.data.locationName) {
                                const location = encodeURIComponent(res.data.locationName);
                                const locationId = encodeURIComponent(res.data.locationIdFilterValue);
                                redirectURL = `${res.data.url}&location=${location}&locationId=${locationId}`;
                            }
                            window.location.href = redirectURL;
                            return;
                        }
                        reportError(res);
                    } catch (err) {
                        reportError(err);
                    } finally {
                        setIsLoading(false);
                        disableElementService.removeDisabledClassOnBody('disableCurrentElementContent--transparent');
                    }
                }
            })();
            return newSelectedFilters;
        });
    };

    return (
        <>
            {isLoading && (
                <div className="loaderContainer">
                    <Loader />
                </div>
            )}
            {errorMsg && <AxiosError />}
            {publicResources && (
                <>
                    <HomeIntro data={{ ...publicResources.homeIntro, quickLinks: publicResources.quickLinks }}>
                        <SearchForm
                            ssrSearchForm={ssrSearchForm || temporarySearchFormDataSSR || null}
                            ssrParameters={parameters}
                            update={updateSelectedFilters}
                            isHome={true}
                        />
                    </HomeIntro>
                    <UniqueValueProposition data={publicResources.uniqueValueProposition} />
                    <AttractiveOfferBanners data={publicResources.attractiveOfferBanners} ssrUserAgent={parameters?.userAgent} />
                    <div className="bottomSectionsContainer">
                        {/*
                            Isti div u obje grane (React ga tretira kao update, ne remount - sprječava reflow).
                            .featuredAccommodation daje širinu (bottomSectionsContainer je flex, align-items:
                            center); marginTop: 0 jer margin-top: 32px već nosi sadržaj unutra.
                        */}
                        {showFeaturedAccommodation ? (
                            <div id="featuredAccommodationSsrFragment" className="featuredAccommodation" style={{ marginTop: 0 }}>
                                <FeaturedAccommodation
                                    accommodation={lastMinuteOffersData}
                                    initialUserWishlist={initialUserWishlist}
                                    openLoginModal={() => setIsLoginModalOpen(true)}
                                    eventNames={{
                                        seeMoreClick: HOMEPAGE_LAST_MINUTE_ITEM_SEE_ALL,
                                        itemClick: HOMEPAGE_LAST_MINUTE_ITEM,
                                        itemView: HOME_PAGE_VIEW_LAST_MINUTE_ITEM,
                                    }}
                                />
                            </div>
                        ) : (
                            <div
                                id="featuredAccommodationSsrFragment"
                                className="featuredAccommodation"
                                style={{ marginTop: 0 }}
                                suppressHydrationWarning={true}
                                // Čuva PHP-om ubačeni SSR HTML netaknutim kroz hidrataciju.
                                dangerouslySetInnerHTML={{ __html: FEATURED_ACCOMMODATION_HTML_FRAGMENT_PLACEHOLDER }}
                            />
                        )}
                        <VacationSuggestions data={publicResources.vacationSuggestions} />
                        <SpecialOffer data={publicResources.specialOffers} />
                        <TopDestinations data={publicResources.topDestinations} />
                        <InternalLinks data={publicResources.marketingInternalLinks} />
                        <NewsletterForm data={publicResources.newsletter} />
                        <Loyality data={publicResources.loyality} />
                        <AboutUsShort
                            data={publicResources.aboutUsShort}
                            testimonials={publicResources.testimonialsSection}
                            data3={publicResources.facts}
                        />
                    </div>
                    <LoginForMoreBenefits isLoginModalOpenOutsideControl={isLoginModalOpen} onModalClose={() => setIsLoginModalOpen(false)} />
                </>
            )}
        </>
    );
}
